import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ChatStateService } from '../../shared-services/chat-state.service';
import { MatTooltipModule } from '@angular/material/tooltip'; // Added import

export interface Macro {
  name: string;
  action: string;
}

@Component({
  selector: 'app-macro-list',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule // Added MatTooltipModule
  ],
  templateUrl: './macro-list.component.html',
  styleUrls: ['./macro-list.component.scss']
})
export class MacroListComponent {

  macros: Macro[] = [];

  constructor(
    public dialogRef: MatDialogRef<MacroListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { macros?: Macro[] },
    private chatStateService: ChatStateService
  ) {
    // SAFELY normalize macros
    this.macros = data?.macros ?? [];
  }

  get hasMacros(): boolean {
    return this.macros.length > 0;
  }

  onMacroClick(macro: Macro): void {
    this.chatStateService.setChatInput(macro.action);
    this.chatStateService.openChat();
    this.dialogRef.close();
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
